import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IAICheckpointGroupModel } from '@fi-shared/fi-ai-assistance/fi-ai-assistance';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-checklist-ai-request-result-group',
    template: `
        <div class="checkpoint-group-name-container BrandedBackgroundColor">
          <span class="checkpoint-group-name">{{ getCheckpointGroupName() }}</span>
        </div>
        
        <div class="checkpoints-preview-container">
          @for (checkpoint of checkpointGroup.Checkpoints; track checkpoint) {
            <mat-card class="checkpoint-preview-card">
              <p class="checkpoint-name" [innerHTML]="checkpoint.Name"></p>
              <p class="checkpoint-description" [innerHTML]="checkpoint.Description"></p>
              <mat-radio-group class="checkpoint-preview-group">
                <mat-radio-button value="ok">{{ 'ok' | fiAppText }}</mat-radio-button>
                <mat-radio-button value="notOk">{{ 'notOk' | fiAppText }}</mat-radio-button>
              </mat-radio-group>
            </mat-card>
          }
        </div>
        `,
    styleUrl: './checklist-ai-request-result-group.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist-ai-request-result-group' },

    standalone: false,
})
export class FiChecklistAiRequestResultGroup {
    @Input() checkpointGroup: IAICheckpointGroupModel;

    constructor(private appTextService: AppTextService) {}

    protected getCheckpointGroupName(): string {
        return this.checkpointGroup.Name ?? this.appTextService.get('checklist.checkpoints');
    }
}
